import { WorkspaceStatus, type WorkspaceStatusConfig } from '../api/workspaces/dto';

export const WORKSPACE_STATUS_CONFIG_MAP: Record<WorkspaceStatus, WorkspaceStatusConfig> = {
  [WorkspaceStatus.Draft]: {
    archived: false,
    createList: false,
    createSchedule: false,
    isDraft: true,
  },
  [WorkspaceStatus.Archived]: {
    archived: true,
  },
  [WorkspaceStatus.Saved]: {
    archived: false,
    createList: false,
    createSchedule: false,
    isDraft: false,
  },
  [WorkspaceStatus.Published]: {
    archived: false,
    createList: true,
  },
};
